import { render, staticRenderFns } from "./AdminDelayConfiguration.vue?vue&type=template&id=6d5ba05e&scoped=true"
import script from "./AdminDelayConfiguration.vue?vue&type=script&lang=js"
export * from "./AdminDelayConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AdminDelayConfiguration.vue?vue&type=style&index=0&id=6d5ba05e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ba05e",
  null
  
)

export default component.exports